import { render, staticRenderFns } from "./TargetTrienniumField.vue?vue&type=template&id=21512cf2&"
import script from "./TargetTrienniumField.vue?vue&type=script&lang=js&"
export * from "./TargetTrienniumField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports